import { Action, getModule, Module, VuexModule } from 'vuex-module-decorators'
import store from '@/store'
import router from '@/router'
import typedStore from '@/store/typedStore'

type StoryPathMessageData = { type: string, storyPath: string }
type StoryPathMessageEvent = MessageEvent<StoryPathMessageData>

@Module({ dynamic: true, store, name: 'iframe', namespaced: true })
export default class Iframe extends VuexModule {
  @Action({ rawError: true })
  sendUpdateStoryPathMessage (storyPath?: string) {
    const targetWindow = window.parent
    const targetOrigin = process.env.VUE_APP_CITIZEN_BILLING_VIEW_URL
    if (targetWindow.origin !== targetOrigin) return

    const message: StoryPathMessageData = {
      type: 'updateStoryPath',
      storyPath: storyPath || typedStore.public.display.storyPath.toString(),
    }

    if (!targetWindow) throw new Error('Bubbles has no target window when attempting to update story path')
    if (!targetOrigin) throw new Error('Bubbles has no target origin when attempting to update story path')

    targetWindow.postMessage(message, targetOrigin)
  }

  @Action({ rawError: true })
  enableStoryPathListener () {
    const validOrigins = process.env.NODE_ENV === 'development'
      ? ['http://localhost:8083']
      : [
        process.env.VUE_APP_CITIZEN_BILLING_VIEW_URL,
        'https://citizen-billing-view.stage.orbviz.com',
      ]

    window.addEventListener('message', (event: StoryPathMessageEvent) => {
      if (!validOrigins.includes(event.origin)) return
      if (event.data.type !== 'changeStoryPath') return

      if (typeof event.data.storyPath === 'string') {
        router.push({ params: { storyPath: event.data.storyPath } })
      }
    })
  }
}

export const IframeModule = getModule(Iframe)
